// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBqemd32stTESd1qeRdv0XqaU78TdRb8uU",
  authDomain: "portfolio-cd1c3.firebaseapp.com",
  projectId: "portfolio-cd1c3",
  storageBucket: "portfolio-cd1c3.firebasestorage.app",
  messagingSenderId: "364107286848",
  appId: "1:364107286848:web:27bf958dfb59816087d2a5",
  measurementId: "G-7P65XQ083J",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app);
